export const PFR_PROGRESS_TRACK = 'PFR_PROGRESS_TRACK'
export const PFR_SLIDER_THUMB = 'PFR_SLIDER_THUMB'
